export default __webpack_public_path__ + "static/h-beam_ls-f9100c67d8028af476427a1e992ce728.jpeg";